import { UpdatePackageInstallationsCount } from "@/model/data/updates/UpdatePackageInstallationsCount";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetVisibleUsersResData extends ServiceResponseData {
    visibleUsers: string[];

    constructor(response: AxiosResponse) {
        super(response);
        this.visibleUsers = new Array<string>();
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.VisibleUsers && obj.VisibleUsers.length > 0) {
            obj.VisibleUsers.forEach((username) => {
                this.visibleUsers.push(username);
            });
        }
    }
}
